import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AboutPage, ContactPage, ExperiencePage, HomePage, MethodPage, NotFoundPage, ProjectDetailPage, ProjectsPage, ServiceLandingPage, serviceLandings } from "./pages/PublicPages";

const admin = () => import("./pages/AdminPages");
const AdminShell = lazy(() => admin().then((module) => ({ default: module.AdminShell })));
const AdminDashboard = lazy(() => admin().then((module) => ({ default: module.AdminDashboard })));
const AdminAnalytics = lazy(() => admin().then((module) => ({ default: module.AdminAnalytics })));
const AdminProjects = lazy(() => admin().then((module) => ({ default: module.AdminProjects })));
const ProjectEditor = lazy(() => admin().then((module) => ({ default: module.ProjectEditor })));
const AdminSettings = lazy(() => admin().then((module) => ({ default: module.AdminSettings })));
const AdminBackup = lazy(() => admin().then((module) => ({ default: module.AdminBackup })));
const AdminTrash = lazy(() => admin().then((module) => ({ default: module.AdminTrash })));
const AdminNotFound = lazy(() => admin().then((module) => ({ default: module.AdminNotFound })));
const localAdminEnabled = import.meta.env.VITE_ENABLE_LOCAL_ADMIN !== "false";

export function App() {
  return <Suspense fallback={<div className="route-loading" role="status">Carregando interface…</div>}><Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/sobre" element={<AboutPage />} />
    <Route path="/experiencia" element={<ExperiencePage />} />
    <Route path="/projetos" element={<ProjectsPage />} />
    <Route path="/projetos/:slug" element={<ProjectDetailPage />} />
    <Route path="/metodo" element={<MethodPage />} />
    <Route path="/contato" element={<ContactPage />} />
    <Route path="/projects" element={<Navigate to="/projetos" replace />} />
    <Route path="/contact" element={<Navigate to="/contato" replace />} />
    <Route path="/skills" element={<Navigate to="/sobre" replace />} />
    {serviceLandings.map((landing) => <Route key={landing.slug} path={`/${landing.slug}`} element={<ServiceLandingPage landing={landing} />} />)}
    {localAdminEnabled && <Route path="/admin" element={<AdminShell />}>
      <Route index element={<AdminDashboard />} />
      <Route path="metricas" element={<AdminAnalytics />} />
      <Route path="projetos" element={<AdminProjects />} />
      <Route path="projetos/novo" element={<ProjectEditor />} />
      <Route path="projetos/:id" element={<ProjectEditor />} />
      <Route path="configuracoes" element={<AdminSettings />} />
      <Route path="backup" element={<AdminBackup />} />
      <Route path="lixeira" element={<AdminTrash />} />
      <Route path="*" element={<AdminNotFound />} />
    </Route>}
    <Route path="*" element={<NotFoundPage />} />
  </Routes></Suspense>;
}
